import { getNextSibling } from "../lib/index.js";
import { mergeListWithPreviousSiblingList } from "../transformations/index.js";
/**
 * If there are 2 "lists" of the same type next to each other, merge them together.
 * If there are 2 nested "lists" next to each other, merge them together.
 */
export function normalizeSiblingLists(editor, entry) {
  var normalized = mergeListWithPreviousSiblingList(editor, entry);
  if (normalized) {
    return true;
  }
  var [, path] = entry;
  var nextSibling = getNextSibling(editor, path);
  if (!nextSibling) {
    return false;
  }
  return mergeListWithPreviousSiblingList(editor, nextSibling);
}